<section class="filters-draw" directive-draw-offset directive-draw-follow="parent">
    <div class="filters-draw__wrapper wrapper">
        <div class="filters-draw__inner row">

            <div class="filters-draw__bd col">

                <ng-template #filtersForLocationMode>
                    <shared-search-for-locations-filter class="filters-draw__filter"
                        [ngClass]="{'is-visible': isVisible | async}"></shared-search-for-locations-filter>
                </ng-template>

                <ng-template #filtersForVenueMode>
                    <shared-pickup-for-filter class="filters-draw__filter"
                        [ngClass]="{'is-visible': isVisible | async}"></shared-pickup-for-filter>
                </ng-template>

                <ng-container *ngIf="(isHomePage$ | async) || (isLocationsSearchPage$ | async)">
                    <projection-for-location-mode class="filters-draw__item"
                        [ngClass]="{'-full-width': (isVenueMode$ | async) !== true}" [location]="filtersForLocationMode"
                        [venue]="filtersForVenueMode">
                    </projection-for-location-mode>
                </ng-container>

                <ng-container *ngIf="(isLocationDetailsPage$ | async) && (canShowOnlineMenu$ | async) === true">
                    <shared-online-menu-nav></shared-online-menu-nav>
                </ng-container>

                <ng-container *ngIf="(isAccountPage$ | async)">
                    <shared-account-draw-menu class="filters-draw__item -full-width">
                    </shared-account-draw-menu>
                </ng-container>

                <ng-container *ngIf="isCheckoutPage$ | async">
                    <shared-link (onClick)="handleBackToMenuClick($event)" feel="plain" icon="back-arrow"
                        [emphasis]="false" class="filters-draw__backlink">Back to menu</shared-link>

                    <shared-link *ngIf="!(isAuthorizedMember$ | async)" (onClick)="handleSignInClick($event)"
                        feel="plain" [emphasis]="true" class="filters-draw__sign-in-link">Sign in</shared-link>
                </ng-container>

                <ng-container *ngIf="isLoyaltyHome$ | async">
                    <shared-btn class="filters-draw__create-account-link" (onClick)="handleCreateAccountClick($event)">
                        Create Account</shared-btn>

                    <shared-link (onClick)="handleSignInClick($event)" feel="plain" [emphasis]="true"
                        class="filters-draw__sign-in-link">Sign in</shared-link>
                </ng-container>

            </div>

        </div>
    </div>
</section>